// Pure, dependency-free decision for where a new signup lands. Kept free of runtime
// imports so it runs under `node --test` (see post_signup_destination.test.ts).

export type PostSignupInput = {
  /** The `?next=` the visitor arrived with, if any. */
  next: string | null | undefined;
  /** True when a `?c=` access code is pending (university students already get Premium). */
  hasAccessCode: boolean;
};

function pointsAtPricing(next: string): boolean {
  const path = next.split(/[?#]/, 1)[0] ?? '';
  return path === '/pricing' || path === '/pricing/';
}

/**
 * Every new signup lands on /pricing, carrying the page they came from as `?next=` so
 * pricing can send them back. Access-code redemptions keep their own destination because
 * they must never hit the paywall.
 */
export function postSignupDestination({next, hasAccessCode}: PostSignupInput): string {
  if (hasAccessCode) return next || '/dashboard';
  if (!next) return '/pricing';
  if (pointsAtPricing(next)) return next;
  return `/pricing?next=${encodeURIComponent(next)}`;
}
